import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/home'
// import push from './push'
import admin from './admin'
import organization from './organization'
import notice from './notice'
import login from './login'
import giasInput from './giasInput'
import store from '../store'
import createEval from './createEval'
import certificate from './certificate'
const router = createRouter({
    history: createWebHistory(),
    // routes: dynamic(store)
    routes: [
        {
            path: '/', 
            name: 'Home', 
            component: Home,
            
        },
        ...createEval,
        ...admin,
        ...notice,
        ...login,
        ...organization,
        ...giasInput,
        ...certificate
    ]
})

export default router;  
